module.exports = __webpack_public_path__ + "static/img/hbszyy.82962a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/hbszyy.png
// module id = WZuY
// module chunks = 0